import * as actions from '../constants/subSkillConstants';

const initialState = {
	subSkills: [],
    getSkill:[],
	searchResults: [],
	page: 1,
};

export const SubSkillReducers = (state = initialState, action) => {
	switch (action.type) {
		case actions.FETCH_SUBSKILL_REQUEST:
			return {
				...state,
				loading: true,
			};
		case actions.FETCH_SUBSKILL_SUCCESS:
			return {
				...state,
				loading: false,
				subSkills: action.payload.data,
				searchResults: action.payload.data,
			};
		case actions.FETCH_SUBSKILL_FAILED:
			return {
				...state,
				loading: false,
				error: action.payload.data,
			};
        case actions.GET_SUBSKILL_GROUP:
            return {
                ...state,
                loading: false,
                getSkill: action.payload.data,
            };
		case actions.SORT_SUBSKILL_ASC:
			const sortAsc = action.payload.sort((a, b) => (a.group_name < b.group_name ? 1 : a.group_name > b.group_name ? -1 : 0));
			return {
				...state,
				subSkills: sortAsc,
			};
		case actions.SORT_SUBSKILL_DESC:
			const sortDesc = action.payload.sort((a, b) => (a.group_name < b.group_name ? -1 : a.group_name > b.group_name ? 1 : 0));
			return {
				...state,
				subSkills: sortDesc,
			};
		case actions.SEARCH_SUBSKILL:
			return {
				...state,
				subSkills: action.payload,
				page: 1
			};
		case actions.SEARCH_SUBSKILL_DEPARTMENT:
			
			return {
				...state,
				subSkills: action.payload,
				page: 1
			};
		default:
			return state;
	}
};